/** Which illustration to show. */
export enum PVisualType {
  EMPTY = 'ds-visual-empty-state',
  WELCOME = 'ds-visual-welcome-state',
  UP_SELL = 'ds-visual-up-sell-state',
  NOT_READY_YET = 'ds-visual-not-ready-yet',
}

/** Which layout to render, independent of the illustration. */
export enum PVisualVariant {
  EMPTY_STATE = 'emptyState',
  UP_SELL = 'upSell',
}
